import { ReactElement, CSSProperties } from 'react'
import { ValueItem } from '@/common/@types'
import { SAFE_BOTTOM } from '@/common/constant'
import './index.css'

const POSITION_TYPE = {
  CENTER: 'center',
  BOTTOM: 'bottom',
} as const
const positionType = Object.values(POSITION_TYPE)
export type PositionTypeVo = ValueItem<typeof positionType>

/**
 * 弹框
 * @param visible  模态弹窗是否可见
 * @param position  模态弹窗位置
 * @param title  模态窗标题
 * @param header  模态窗自定义头部
 * @param content  弹窗的内容
 * @param cancelText  自定义关闭按钮文案
 * @param confirmText  自定义确认按钮文案
 * @param showCancelButton  是否显示关闭按钮
 * @param showConfirmButton  是否显示确认按钮
 * @param onCancel  取消函数
 * @param onConfirm  确定函数
 * @param backdrop  是否显示遮罩层
 * @param backdropClosable  点击遮罩层是否关闭模态框
 * @param children  弹框自定义内容
 */
const Modal = ({
  visible,
  position = POSITION_TYPE.CENTER,
  title,
  header,
  content,
  cancelText = 'cancel',
  confirmText = 'confirm',
  showCancelButton,
  showConfirmButton = true,
  modalStyle = {},
  onCancel,
  onConfirm,
  backdrop = true,
  backdropClosable,
  children,
}: {
  visible: boolean
  position?: PositionTypeVo
  title?: string
  header?: ReactElement
  content?: ReactElement
  cancelText?: string
  confirmText?: string
  showCancelButton?: boolean
  showConfirmButton?: boolean
  onCancel?: () => void
  onConfirm?: () => void
  backdrop?: boolean
  backdropClosable?: boolean
  children?: ReactElement
  modalStyle?: CSSProperties
}) => (
  <view>
    {visible ? (
      <modal>
        <view
          className={backdrop ? 'dialog-mask' : 'dialog-noMask'}
          style={{ alignItems: `${position === POSITION_TYPE.CENTER ? 'center' : 'flex-end'}` }}
          onClick={backdropClosable && onCancel ? onCancel : () => {}}
        >
          <view
            className="dialog-container"
            style={{ ...modalStyle, margin: `${position === POSITION_TYPE.BOTTOM ? 0 : '0 24'}` }}
            onClick={() => {
              // do noting 防止点击内容区域弹窗消失
            }}
          >
            {header || (
              <view className="dialog-content">
                {title ? <text className="dialog-title" content={title} /> : null}
                {content && content}
              </view>
            )}
            {children && children}
            {showConfirmButton ? (
              <view className="dialog-button" style={{ paddingBottom: `${showCancelButton ? 12 : position === POSITION_TYPE.BOTTOM ? SAFE_BOTTOM : 24}` }}>
                <text
                  className="dialog-button-text dialog-confirm-button"
                  onClick={() => {
                    onConfirm && onConfirm()
                  }}
                >
                  {confirmText}
                </text>
              </view>
            ) : null}
            {showCancelButton ? (
              <view className="dialog-button" style={{ paddingBottom: `${position === POSITION_TYPE.BOTTOM ? SAFE_BOTTOM : 24}` }}>
                <text
                  className="dialog-button-text"
                  onClick={() => {
                    onCancel && onCancel()
                  }}
                >
                  {cancelText}
                </text>
              </view>
            ) : null}
          </view>
        </view>
      </modal>
    ) : null}
  </view>
)

export default Modal
